<template>
  <section class="page">
    <b-container>
      <div v-for="item in content" v-bind:key="item.rawValue">
        <div v-if="item.field === 'content_section'">
          <b-row>
            <div
              v-html="item.rawValue"
              class="col-sm-12 col-md-12 col-lg-8 story "
            ></div>
          </b-row>
        </div>
      </div>
    </b-container>
  </section>
</template>

<script>
export default {
  props: ["content"],
  name: "ContentPage"
};
</script>

<style scoped>
.story {
  padding-top: 60px;
}

.card {
  font-family: "Open Sans Condensed", sans-serif;
}
.card a,
.card .action {
  color: red;
}
.hdr {
  display: none;
}
</style>
